/* ---------- CP-001's motor cable to 4G4 (#921, owner 8 October) ----------
 * An earth fault at the motor must trip -QA1's instantaneous release even at the top of its tolerance, so the reference -WD1 is 4G4
 * (-XD1's variant "4.0"); 4G1.0, 4G1.5 and 4G2.5 are unsuitable. How a save made with an older cable is read with the new one: the
 * save migration in packages/progress uses it (format 9). Self-contained on purpose, as rename.ts: the migration imports this file
 * alone, not CP-001's model. */

/** -XD1's variant for the reference motor cable, 4G4 */
export const CP001_CABLE = "4.0";

/** A save with a motor cable other than 4G4, read with 4G4:
 *  - a commissioning not yet signed: -XD1 becomes 4G4, and the readings the cable decides (the motor's earth and the motor circuit's
 *    continuity) are cleared, so those tests come back; their old readings were judged against the old cable's limits. The rest stays.
 *  - a signed commissioning: left as it is, cable and all. A signed report is the record of the panel that was tested.
 *  Anything else (no model, no -XD1, already 4G4) comes back unchanged. */
export function cableCp001Save<T extends { model?: unknown; ui?: any }>(s: T): T {
  if (!s || !s.model || s.ui?.com?.complete) return s;
  const text = typeof s.model === "string";   // the model as saved: JSON text, or the object itself
  let m: any; try { m = text ? JSON.parse(s.model as string) : JSON.parse(JSON.stringify(s.model)); } catch { return s; }
  const x = (m?.components || []).find((c: any) => c?.tag === "XD1" && c?.type === "terminal_block");
  if (!x || x.properties?.variant === CP001_CABLE) return s;
  x.properties = { ...(x.properties || {}), variant: CP001_CABLE };
  const out: any = { ...s, model: text ? JSON.stringify(m) : m }, com = s.ui?.com;
  if (com?.rec) {
    const rec = { ...com.rec, earth: false, cont: [] }, vals = { ...(com.vals || {}) }; delete vals.earth; delete vals.cont;
    out.ui = { ...s.ui, com: { ...com, rec, vals } };
  }
  return out;
}
